var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-form" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.devcManual, rules: _vm.rules }
        },
        [
          _vm.manualId != null && _vm.manualId > 0
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("名称")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "fileName" } },
                      [
                        _c("el-input", {
                          staticClass: "width-1-5x",
                          attrs: { type: "text" },
                          model: {
                            value: _vm.devcManual.fileName,
                            callback: function($$v) {
                              _vm.$set(_vm.devcManual, "fileName", $$v)
                            },
                            expression: "devcManual.fileName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.manualId != null && _vm.manualId > 0
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("使用范围")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "innerOnly" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.devcManual.innerOnly,
                              callback: function($$v) {
                                _vm.$set(_vm.devcManual, "innerOnly", $$v)
                              },
                              expression: "devcManual.innerOnly"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("通用")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("内部使用")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.manualId == null
            ? _c("div", { staticClass: "form-group top" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("资料手册")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("swb-file-upload", {
                      attrs: {
                        fileFor: "assets",
                        fileGroup: "assets",
                        onBeforeUpload: _vm.onBeforeFileUpload,
                        onProgress: _vm.onProgress,
                        onDone: _vm.onFileUploadDone,
                        multipleFile: true
                      }
                    }),
                    _vm._v(" "),
                    _vm.devcFiles != null && _vm.devcFiles.length > 0
                      ? _c(
                          "ul",
                          { staticClass: "file-area input clearfix" },
                          _vm._l(_vm.devcFiles, function(devcFile, index) {
                            return _c(
                              "li",
                              { staticClass: "file-content clearfix" },
                              [
                                _c("swb-file-item", {
                                  attrs: {
                                    trackKey: index,
                                    fileName: devcFile.fileName,
                                    fileUuid: devcFile.fileUuid,
                                    downloadable: true,
                                    fileDownloadUrl: devcFile.fileBrowseUrl,
                                    deletable: true,
                                    onDelete: function(event) {
                                      _vm.removeFileUpload(event, devcFile)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "file-right" }, [
                                  _c("div", { staticClass: "row clearfix" }, [
                                    _c(
                                      "div",
                                      { staticClass: "label required" },
                                      [_vm._v("名称")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "value" },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "170px" },
                                          attrs: {
                                            placeholder: "请输入手册名称",
                                            type: "text"
                                          },
                                          model: {
                                            value: devcFile.fileName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                devcFile,
                                                "fileName",
                                                $$v
                                              )
                                            },
                                            expression: "devcFile.fileName"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row clearfix" }, [
                                    _c(
                                      "div",
                                      { staticClass: "label required" },
                                      [_vm._v("使用范围")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "value" },
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value: devcFile.innerOnly,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  devcFile,
                                                  "innerOnly",
                                                  $$v
                                                )
                                              },
                                              expression: "devcFile.innerOnly"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: false } },
                                              [_vm._v("通用")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: true } },
                                              [_vm._v("内部使用")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          })
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b80de7a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b80de7a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcDef/MerchtDevcManualSave.vue
// module id = 2410
// module chunks = 0